// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y-UIv","title":"styles_title__1keNw"};